export default __webpack_public_path__ + "static/medicaid-204ebbacd37e1ed613f209b6bb0ab380.jpg";